import { render, staticRenderFns } from "./BackToListPage.vue?vue&type=template&id=457fc7f1"
import script from "./BackToListPage.vue?vue&type=script&lang=js"
export * from "./BackToListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports